import React, { createContext } from "react";
import useGlobal from "../hooks/useGlobal";

export const GlobalContext = createContext(null);

const GlobalProvider = ({ children }) => {
  const allContext = useGlobal();
  return (
    <GlobalContext.Provider value={allContext}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;